"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionAccountStatusType = void 0;
var TransactionAccountStatusType;
(function (TransactionAccountStatusType) {
    TransactionAccountStatusType["PARTNER"] = "PARTNER";
    TransactionAccountStatusType["DIRECT"] = "DIRECT";
    TransactionAccountStatusType["UNAFFILIATED_RESELLER"] = "UNAFFILIATED_RESELLER";
})(TransactionAccountStatusType = exports.TransactionAccountStatusType || (exports.TransactionAccountStatusType = {}));
